import { useEffect, useState } from "react";
import { SunIcon, MoonIcon } from "@heroicons/react/24/solid";
import { motion } from "framer-motion";

export default function ThemeToggle() {
    const [dark, setDark] = useState(false);

    useEffect(() => {
        if (dark) document.documentElement.classList.add("dark");
        else document.documentElement.classList.remove("dark");
    }, [dark]);

    return (
        <motion.button
            onClick={() => setDark(!dark)}
            className="relative p-2 rounded-full bg-gray-200/80 dark:bg-gray-800/80 backdrop-blur-sm text-gray-800 dark:text-white transition-colors hover:bg-gray-300/80 dark:hover:bg-gray-700/80"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            initial={false}
            animate={{ rotate: dark ? 180 : 0 }}
            transition={{ type: "spring", stiffness: 200, damping: 15 }}
        >
            <motion.div
                key={dark ? "sun" : "moon"}
                initial={{ opacity: 0, rotate: -30 }}
                animate={{ opacity: 1, rotate: 0 }}
                exit={{ opacity: 0, rotate: 30 }}
                transition={{ duration: 0.2 }}
            >
                {dark ? (
                    <SunIcon className="h-5 w-5 text-amber-500 dark:text-amber-400" />
                ) : (
                    <MoonIcon className="h-5 w-5 text-indigo-600 dark:text-indigo-400" />
                )}
            </motion.div>
        </motion.button>
    );
}